import { render, staticRenderFns } from "./df-form-email-change.vue?vue&type=template&id=45c07aa9"
import script from "./df-form-email-change.ts?vue&type=script&lang=js&external"
export * from "./df-form-email-change.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports